export const globalSearchEn = {
  predefinedFilter: {
    everywhere: 'Everywhere',
    taskTitles: 'In task titles',
    chatTitles: 'In chat titles',
    messages: 'In messages',
    currentProject: 'In project',
    customFilter: 'Custom filter…'
  },
  categoryAllCaption: 'All categories',
  category: {
    taskTitle: 'In task titles',
    userName: 'In user names',
    groupChatTitle: 'In group chat titles',
    message: 'In messages text',
    description: 'In descriptions',
    checklist: 'In checklists'
  },
  projectsAllCaption: 'All projects'
}

export const globalSearchRu: typeof globalSearchEn = {
  predefinedFilter: {
    everywhere: 'Везде',
    taskTitles: 'В названиях задач',
    chatTitles: 'В названиях чатов',
    messages: 'В сообщениях',
    currentProject: 'В проекте',
    customFilter: 'Свой фильтр…'
  },
  categoryAllCaption: 'Все категории',
  category: {
    taskTitle: 'В названиях задач',
    userName: 'В именах пользователей',
    groupChatTitle: 'В названиях групповых чатов',
    message: 'В тексте сообщений',
    description: 'В описаниях',
    checklist: 'В чеклистах'
  },
  projectsAllCaption: 'Все проекты'
}
